let utils = new function() {
	// eslint-disable-next-line no-extend-native
	Date.prototype.getWeekOfMonth = function() {
		var firstWeekday = new Date(this.getFullYear(), this.getMonth(), 1).getDay();
		var offsetDate = this.getDate() + firstWeekday - 1;
		return Math.floor(offsetDate / 7);
	};

	var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
	let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

	function Copy(obj) {
		return JSON.parse(JSON.stringify(obj));
	}

	this.xDaysAgo = (days) => {
		let daysAgo = 1000 * 60 * 60 * 24 * days;
		return new Date(Date.now() - daysAgo);
	};

	this.copy = function(obj) {
		return Copy(obj);
	};
	this.isValidEmail = (email) => {
		const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	};

	this.isFloat = (n) => {};
	this.isInt = (n) => {
		return Number(n) == n && n % 1 === 0;
	};
	this.isNumber = (n) => {
		return this.isInt(n) || this.isFloat(n);
	};

	this.display_number = (n) => {
		if (!this.isNumber(n)) return n;
		return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	};

	this.display_time_military = (dt) => {
		return DisplayTimeMilitary(dt);
	};

	this.display_time = (dt) => {
		return DisplayTime(dt);
	};

	this.isEmptyObject = (obj) => {
		for (let i in obj) {
			return false;
		}
		return true;
	};

	this.display_actual_date = function(dt) {
		if (!dt) return '';
		if (!IsClientDate(dt)) {
			dt = ServerToClientDateTime(dt);
		}
		if (dt.getTime() == 0) return '';
		let month = dt.getMonth(); //months from 1-12
		let day = dt.getDate();
		let year = dt.getFullYear();
		if (month || day || year) {
			return monthNames[month] + ' ' + day + ', ' + year;
		} else {
			return '';
		}
	};

	this.is_date = (date) => {
		return Object.prototype.toString.call(date) === '[object Date]'
	}

	this.display_actual_datetime = (dt) => {
		let date = this.display_actual_date(dt);
		let time = this.display_time_military(dt);
		return time + ' ' + date;
	};

	this.display_date = function(dt) {
		if (!dt) {
			return '';
		}
		if (!IsClientDate(dt)) {
			dt = ServerToClientDateTime(dt);
		}
		if (SameDayAsCurrent(dt)) {
			return 'Today ' + DisplayTimeMilitary(dt);
		}
		if (Yesterday(dt)) {
			return 'Yesterday ' + DisplayTimeMilitary(dt);
		}
		if (SameWeekAsCurrent(dt)) {
			return DisplayDayOfWeek(dt);
		}
		var month = dt.getMonth(); //months from 1-12
		var day = dt.getDate();
		var year = dt.getFullYear();
		if (month || day || year) {
			return monthNames[month] + ' ' + day + ', ' + year;
		} else {
			return '';
		}
	};

	this.format_money = function(value) {
		value = parseFloat(value);
		return '$' + value.toFixed(2);
	};

	this.client_to_server_datetime = function(dt) {
		return ClientToServerDateTime(dt);
	};

	this.client_to_server_date = function(dt) {
		return ClientToServerDate(dt);
	};

	this.server_to_client_date = function(dt_str) {
		return ServerToClientDate(dt_str);
	};

	this.server_to_client_datetime = function(dt_str) {
		return ServerToClientDateTime(dt_str);
	};

	this.server_to_client_obj = (obj, model_name, meta_data) => {
		var meta = null;
		if (meta_data) {
			meta = meta_data;
		}
		if (obj && Array.isArray(obj)) {
			for (let j in obj) {
				for (let i in meta) {
					if (obj[j][i] !== undefined) {
						obj[j][i] = ServerToClientProperty(obj[j][i], meta[i]);
					}
				}
			}
		} else {
			for (let i in meta) {
				if (obj[i] !== undefined) {
					obj[i] = ServerToClientProperty(obj[i], meta[i]);
				}
			}
		}
		return obj;
	};

	let ServerToClientProperty = (property, metadata) => {
		if (metadata.type === 'date') {
			property = ServerToClientDate(property);
		} else if (metadata.type === 'datetime') {
			property = ServerToClientDateTime(property);
		}else if (metadata.type === 'json') {
			property = JsonToObj(property);
		}
		return property;
	};

	this.client_to_server_obj = (obj, model_name, metadata) => {
		var meta = null;

		if (!meta && metadata) {
			meta = metadata;
		}
		if (obj && Array.isArray(obj)) {
			for (let j in obj) {
				for (let i in meta) {
					if (obj[j][i]) {
						obj[j][i] = ClientToServerProperty(obj[j][i], meta[i]);
					}
				}
			}
		} else {
			for (let k in meta) {
				obj[k] = ClientToServerProperty(obj[k], meta[k]);
			}
		}
		return obj;
	};

	let ClientToServerProperty = (property, metadata) => {
		if (metadata.type === 'date') {
			return ClientToServerDate(property);
		} else if (metadata.type === 'datetime') {
			return ClientToServerDateTime(property);
		} else if (metadata.type === 'related' && property === '') {
			return null;
		} else if (metadata.type === 'boolean') {
			return property ? 1 : 0;
		}

		return property;
	};

	this.file_path_to_base_64 = function(file, callback) {
		FilePathToBase64(file, callback);
	};

	this.call_phone = function(number) {
		CallNumber(number);
	};
	this.message_phone = function(number) {
		OpenMessages(number);
	};

	this.allowNumbersPayRate = function(event) {
		let charCode = event.keyCode;
		if (
			(charCode > 47 && charCode < 58) ||
			charCode === 8 ||
			charCode === 188 ||
			charCode === 190 ||
			charCode === 9 ||
			charCode === 110 ||
			charCode === 46 ||
			charCode === 37 ||
			charCode === 3 ||
			charCode === 17
		) {
			return;
		} else {
			event.preventDefault();
			return false;
		}
	};

	this.addCommasToNumber = (number) => {
		return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	};
	this.generateColor = function() {
		return (
			'#' +
			Math.random()
				.toString(16)
				.substr(-6)
		);
	};

	this.copyText = (id) => {
		let copyText = document.getElementById(id);
		copyText.select();
		document.execCommand('Copy');
	};

	this.formatBase64Data = (string) => {
		return string.split(',')[1];
	};

	function JsonToObj(json) {
		if(typeof json !== 'string') {
			console.error('JsonToObj for non string json', json, JSON.stringify(json))
			return json || {}
		}
		let obj = {};
		try {
			obj = JSON.parse(json);
		} catch (e) {
			console.error(e);
		}
		return obj;
	}

	function DisplayTimeMilitary(date) {
		if (!date || !date.getTime) return '';
		if (date.getTime() == 0) return '';
		let hours = date.getHours();
		let minutes = date.getMinutes();
		if (minutes <= 9) {
			minutes = '0' + minutes;
		}
		let strTime = hours.toString() + ':' + minutes.toString();
		if (hours <= 9) {
			strTime = '0' + hours + ':' + minutes;
		}
		return strTime;
	}

	function DisplayTime(date) {
		var hours = date.getHours();
		var minutes = date.getMinutes();
		var ampm = hours >= 12 ? 'pm' : 'am';
		hours = hours % 12;
		hours = hours ? hours : 12; // the hour '0' should be '12'
		minutes = minutes < 10 ? '0' + minutes : minutes;
		var strTime = hours + ':' + minutes + ' ' + ampm;
		return strTime;
	}

	function DisplayDayOfWeek(date) {
		return days[date.getDay()];
	}

	function SameWeekAsCurrent(dt) {
		var current = new Date();
		if (current.getWeekOfMonth() !== dt.getWeekOfMonth()) {
			return false;
		}
		if (current.getMonth() !== dt.getMonth()) {
			return false;
		}
		if (current.getFullYear() !== dt.getFullYear()) {
			return false;
		}
		return true;
	}

	function SameDayAsCurrent(dt) {
		if (!dt) {
			return false;
		}
		var current = new Date();
		if (current.getDate() !== dt.getDate()) {
			return false;
		}
		if (current.getMonth() !== dt.getMonth()) {
			return false;
		}
		if (current.getFullYear() !== dt.getFullYear()) {
			return false;
		}
		return true;
	}

	function Yesterday(dt) {
		var currentDate = new Date();
		var todayMidnight = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
		var yesterdayMidnight = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 1);
		if (dt.getTime() >= yesterdayMidnight.getTime() && dt.getTime() <= todayMidnight.getTime()) {
			return true;
		}
		return false;
	}

	function ClientToServerDateTime(dt) {
		if (IsClientDate(dt)) {
			return dt
				.toISOString()
				.slice(0, 19)
				.replace('T', ' ');
		} else {
			return dt;
		}
	}

	function ClientToServerDate(dt) {
		if (IsClientDate(dt)) {
			return dt.toISOString().substring(0, 10);
		} else {
			return dt;
		}
	}

	function ServerToClientDate(dt_str) {
		if (dt_str === null) {
			return null;
		}
		if (IsClientDate(dt_str)) {
			return dt_str;
		}
		let date = new Date(dt_str);
		return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
	}

	function ServerToClientDateTime(dt_str) {
		if (IsClientDate(dt_str)) {
			return dt_str;
		}
		if (!dt_str) {
			return new Date(''); //invalid Date
		}
		if (dt_str == parseInt(dt_str)) {
			return new Date(dt_str);
		}
		if (!dt_str.replace) {
			return new Date(''); //invalid Date
		}
		let date = DateFromString(dt_str);
		return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
	}

	function DateFromString(dt_str) {
		if (!dt_str || !dt_str.replace) return new Date('');
		dt_str = dt_str.replace('T', ' ').replace('Z', '');
		let a = dt_str.split(/[^0-9]/).map((s) => {
			return parseInt(s, 10);
		});
		return new Date(a[0], a[1] - 1 || 0, a[2] || 1, a[3] || 0, a[4] || 0, a[5] || 0, a[6] || 0);
	}

	function IsClientDate(dt) {
		if (dt && dt.getTime && typeof dt.getTime === 'function') {
			return true;
		} else {
			return false;
		}
	}

	this.is_client_date = function(dt) {
		return IsClientDate(dt);
	};

	this.query_string = () => {
		let queryString = window.location.search;
		let query = {};
		let pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
		for (let i = 0; i < pairs.length; i++) {
			var pair = pairs[i].split('=');
			query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
		}
		return query;
	};

	function FilePathToBase64(file, callback) {
		var img = new Image();
		img.crossOrigin = 'Anonymous';
		img.src = file;
		img.onload = function() {
			var canvas = document.createElement('canvas');
			var ctx = canvas.getContext('2d');
			canvas.height = img.height;
			canvas.width = img.width;
			ctx.drawImage(img, 0, 0);
			var dataURL = canvas.toDataURL('image/jpeg').slice(23);
			canvas = null;
			var filename = file.match(/([a-zA-Z0-9-_.]+\..*)/g)[0];
			callback(dataURL, filename);
		};
	}

	function OpenMessages(number) {
		window.open('sms:' + number);
	}

	function CallNumber(number) {
		window.open('tel:' + number);
	}

	this.parseJSON = (data) => {
		let obj = null;
		try {
			obj = JSON.parse(data);
		} catch (e) {
			return data;
		}
		return obj;
	};

	this.capitalize = (str) => {
		if (typeof str !== 'string') return '';
		return (str[0] || '').toUpperCase() + (str.substring(1, str.length) || '');
	};

	this.capitalizeWords = (str) => {
		if (typeof str !== 'string') return '';
		return str
			.toLowerCase()
			.split(' ')
			.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
			.join(' ');
	};

	this.utcHour = (hourInTimeZone) => {
		let offset = new Date().getTimezoneOffset() / 60;
		let utc = hourInTimeZone + offset;
		if (utc < 0) {
			return 24 - Math.abs(utc);
		}
		return utc % 24;
	};

	this.getTextWidth = (fontSize, value) => {
		let div = document.createElement('div');
		div.innerHTML = value;
		div.style.fontSize = fontSize;
		div.style.width = 'auto';
		div.style.display = 'inline-block';
		div.style.visibility = 'hidden';
		div.style.position = 'fixed';
		div.style.overflow = 'auto';
		document.body.append(div);
		let width = div.clientWidth;
		div.remove();
		return width;
	};

	//getSort is a callback function that works in conjunction with the array.sort method to allow for the ordering of different types of object datas in an array list.
	//The property param refers to the name of the property being sorted. The type param refers to the type of data eg. string, date, number. The desc param
	//refers to the direction of sorting eg. descending or ascending.
	this.getSort = function(property, type, desc) {
		let opposite = { '-1': 1, '1': -1 };
		return (a, b) => {
			let aValue = getSortValue(a[property], type);
			let bValue = getSortValue(b[property], type);
			let val = 1;
			if (aValue > bValue) val = -1;
			if (!desc) val = opposite[val];
			if (type === 'string') val = opposite[val];
			return val;
		};
	};

	this.upperCase = (string) => {
		if (typeof string !== 'string') return '';
		return string.toUpperCase();
	};

	function getSortValue(value, type) {
		if (type == 'string') {
			if (!value || !value.toLowerCase) return '';
			return value.toLowerCase();
		} else if (type === 'datetime') {
			if (!value || !value.getTime) return 0;
			return value.getTime();
		} else if (type == 'number') {
			if (!value) return 0;
			return value;
		}
	}
  this.uuid = () =>{
    var d = new Date().getTime();//Timestamp
    var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16;//random number between 0 and 16
      if(d > 0){//Use timestamp until depleted
        r = (d + r)%16 | 0;
        d = Math.floor(d/16);
      } else {//Use microseconds since page-load if supported
        r = (d2 + r)%16 | 0;
        d2 = Math.floor(d2/16);
      }
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

}();
export default utils;
window.utils = utils;



// WEBPACK FOOTER //
// ./src/utils/utils.js